import { render, staticRenderFns } from "./PronuncationTry.vue?vue&type=template&id=6df77d78&lang=pug&"
import script from "./PronuncationTry.vue?vue&type=script&lang=js&"
export * from "./PronuncationTry.vue?vue&type=script&lang=js&"
import style0 from "./PronuncationTry.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports